import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { tap, catchError, throwError } from 'rxjs';
import { ApplicationInsightsService } from './application-insights.service';

export const telemetryInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const appInsights = inject(ApplicationInsightsService);
  const startTime = performance.now();

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event.type === 4) {
          const duration = performance.now() - startTime;
          const response = event as { status?: number };
          appInsights.trackHttpRequest(
            req.url,
            req.method,
            duration,
            true,
            response.status ?? 200
          );
        }
      },
    }),
    catchError((error) => {
      const duration = performance.now() - startTime;
      appInsights.trackHttpRequest(
        req.url,
        req.method,
        duration,
        false,
        error.status ?? 0,
        {
          errorMessage: error.message,
          errorName: error.name,
        }
      );
      return throwError(() => error);
    })
  );
};
